import axios from "axios";
import DomainName from "../serverConfig/serverconfig";
import { SOMETHING_WRONG, Types } from "./request";
import { Platform } from "react-native";
import { CryptoEncrypt } from "../utils/encrypt";
import AsyncStorage from "@react-native-community/async-storage";
import {
  get_overdue_details,
  GETSERVICE,
  UPLOADFILES,
  GET_SOURCE_ID,
  UPLOAD_FILES_PEBBLE,
} from "../../src/serverConfig/microService";

const isLocalhost = window.location.hostname === "localhost";
const isDebugMode = isLocalhost || localStorage.getItem('inspect_api');

// * urls can be configured in webpack-dev-server.config.v5.js
const PROXIES = {
  STAGING: "/api-staging",
  UAT: "/api-uat",
  PROD: "/api-prod",
  DISABLE: false,
};

const USE_API_PROXY = PROXIES.DISABLE; // * set false to disable proxy

let letEncrypt = false;
let apiKey = "4f7026f8-ed27-4d0b-b6d2-f89a38dcd0d2";
let Key = "4f7026f8-ed27-4d0b-b6d2-f89a38dcd0d2";

// * staging keys
// apiKey = "b4c0fd56-895d-4a25-a0bd-d04147862fd8";
// Key = apiKey;

if (USE_API_PROXY == PROXIES.UAT) {
  // * uat keys
  apiKey = "b4c0fd56-895d-4a25-a0bd-d04147862fd8";
  Key = apiKey;
}

const encryptionFlag = (url, hostname) => {
  // return true;
  // * disable encryption for whitelisted hostnames
  const whitelist = [
    "service-uat.icicibank.com",
    "csrstaging.niveussolutions.com",
    "csr.niveussolutions.com",
    "localhost",
  ];

  if (whitelist.includes(hostname)) {
    return false;
  }

  // * enable encryption for everything else
  return true;
};

const ApiURL = () => {
  if (USE_API_PROXY) {
    return USE_API_PROXY;
  }

  const domainMap = {
    "service.icicibank.com": DomainName.DOMAIN_NAME_PROD,
    "overduepreprod.icicibank.com": DomainName.DOMAIN_NAME_PRE_PROD,
    "csrstaging.niveussolutions.com": DomainName.DOMAIN_NAME_STAG,
    "csr.niveussolutions.com": DomainName.DOMAIN_NAME_DEV,
    "csroverdue.niveussolutions.com": DomainName.DOMAIN_NAME_OVERDUE,
    "service-uat.icicibank.com": DomainName.DOMAIN_NAME_UAT,
  };

  const domain = window.location.hostname;
  return domainMap[domain] || DomainName.DOMAIN_NAME_STAG;
};

const instance = axios.create({
  baseURL: ApiURL(),
});

let TAG = "APIREQUEST";

const makeAPICall = async (request, changeTransactionId, secret) => {
  let hostname = window.location.hostname;

  const cancelTokenSource = axios.CancelToken.source();

  const { type, url, payload, tag } = request;
  TAG = tag;

  const isEncryptionDisabled =
    url.includes(GETSERVICE) ||
    url.includes(UPLOADFILES) ||
    url.includes(UPLOAD_FILES_PEBBLE) ||
    url.includes(GET_SOURCE_ID);

  if (url.includes(get_overdue_details)) {
    apiKey = "0b20c4d8-bb43-4637-b8df-395c16ee8bbc";
  }
  if (isEncryptionDisabled) {
    letEncrypt = false;
  } else {
    letEncrypt = encryptionFlag(request.url, hostname);
  }

  instance.defaults.timeout = 120000;
  instance.defaults.headers.post["Content-Type"] = "application/json";
  instance.defaults.headers.post["Accept"] = "application/json";
  instance.defaults.headers.post["apiKey"] = apiKey;
  let authRequired;
  if (
    request.authRequired === "undefined" ||
    request.authRequired === undefined
  ) {
    authRequired = true;
  } else {
    authRequired = request.authRequired;
  }

  let userToken;
  if (Platform.OS === "web") {
    userToken = sessionStorage.getItem("token");
  } else {
    userToken = await AsyncStorage.getItem("token");
  }
  let sourceKey;
  if (Platform.OS === "web") {
    sourceKey = sessionStorage.getItem("sourceKey");
  } else {
    sourceKey = await AsyncStorage.getItem("sourceKey");
  }

  if (authRequired) {
    instance.defaults.headers.common.Authorization = `Bearer ${userToken}`;
  } else {
    delete instance.defaults.headers.common.Authorization;
  }
   if (sourceKey) {
      instance.defaults.headers.common.Key = `${sourceKey}`;
    } else {
       instance.defaults.headers.common.Key = Key;
    }
  if (
    url === "/communication/updateCustomerDetails" &&
    sessionStorage.getItem("isConfirmManger")
  ) {
    let n = sessionStorage.getItem("counter");
    if (n === null) {
      n = 1;
    } else {
      n++;
    }
    sessionStorage.setItem("counter", n);
    let updatedCount = sessionStorage.getItem("counter");
    if (updatedCount > 1) {
      cancelTokenSource.cancel();
    }
  }
  let axiosRequest;
  let EncryptedPload;
  if (Platform.OS == "web") {
    EncryptedPload = letEncrypt
      ? CryptoEncrypt.encrypt(payload, secret)
      : payload;
  } else {
    EncryptedPload = payload;
  }
  if (type === Types.GET) {
    axiosRequest = instance.get(url);
  } else if (type === Types.POST) {
    axiosRequest = instance.post(url, EncryptedPload, {
      cancelToken: cancelTokenSource.token,
    });
  }
  // * encryption is disabled for get methods and isEncryptionDisabled
  await localStorage.setItem("prevUrl", url);
  return axiosRequest
    .then((response) => {
      let decryptedData;
      if (Platform.OS == "web") {
        if (isEncryptionDisabled) {
          letEncrypt = false;
        } else {
          letEncrypt = encryptionFlag(response.config.url, hostname);
        }
        var ENCRYPTED_KEY = changeTransactionId(response.data.part2);
        decryptedData =
          response.config.method !== "get" && letEncrypt
            ? {
                ...response,
                data: CryptoEncrypt.decrypt(response.data.part1, ENCRYPTED_KEY),
              }
            : response;
      } else {
        decryptedData = response;
      }
      let result = { ...decryptedData, tag: tag };
      if (isDebugMode) {
        console.log(TAG, result);
      }
      return result;
    })
    .catch(function (error) {
      if (isDebugMode) {
        console.log(TAG, `inside catch of api call....${error}`, error);
        console.log(TAG, error.request);
      }

      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx

        let decryptedData = error.response;

        if (isDebugMode) {
          console.log(TAG, decryptedData);
        }

        if (isEncryptionDisabled) {
          letEncrypt = false;
        } else {
          letEncrypt = encryptionFlag(error.response.config.url, hostname);
        }
        var ENCRYPTED_KEY = changeTransactionId(decryptedData.data.part2);
        decryptedData =
          error.response.config.method !== "get" && letEncrypt
            ? {
                ...error.response,
                data: CryptoEncrypt.decrypt(
                  decryptedData.data.part1,
                  ENCRYPTED_KEY
                ),
              }
            : error.response;

        const err = {
          code: decryptedData.status,
          message: decryptedData.statusText,
          data: decryptedData.data,
          tag,
        };
        throw err;
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js

        if (isDebugMode) {
          console.log(TAG, "some unwanted error of api call....");
          console.log("error", error);
        }
        const err = {
          code: SOMETHING_WRONG,
          tag,
        };
        throw err;
      } else {
        // * Something happened in setting up the request that triggered an Error
        if (isDebugMode) {
          console.log(TAG, "some unwanted error2 of api call....");
          console.log("error", error);
        }
        const err = {
          code: SOMETHING_WRONG,
          tag,
        };
        throw err;
      }
    });
};

export default makeAPICall;
